import React from 'react';
import PropTypes from 'prop-types';

import { balanceApi } from 'helpers/api/balance';

import { Icon } from 'components/Icon';
import { HiddenInput } from 'components/HiddenInput';
import { ButtonIcon } from 'components/Button';
import { CalculatorModal } from 'components/CalculatorModal';

const TableContinueInstruments = ({
  data,
  opened,
  canChange,
  rentSum,
  handleRemoveComponent,
  handleAddComponent,
  handleUpdateComponent,
  handleRemove,
  handleChangeCalculator,
  handleOpen,
  onUpdate,
  rateVAT,
  calculator,
  handleCalculator,
  isFullPledge,
  setIsFullPledge,
}) => {
  const recalculateRentSum = (insts) => {
    balanceApi.calculateInstrumentAmountContinue(insts).then(({ data } = {}) => {
      handleChangeCalculator(data);
    });
  };

  const onAdditionalRentTermChange = (value) => {
    const newData = data.map((elem) => {
      return { ...elem, AdditionalRentTerm: value };
    });
    onUpdate(newData);
    
    recalculateRentSum(newData);
  };

  return (
    <table className="table-instruments">
      <thead>
        <tr className="table-inst-htr">
          <th className="table-inst-th" width="30px">
            №
          </th>
          <th className="table-inst-th" width="16px" style={{ borderRight: 'none', textAlign: 'left' }}></th>
          <th className="table-inst-th" align="start">
            Наименование
          </th>
          <th className="table-inst-th" width="50px">
            Срок
          </th>
          <th className="table-inst-th" width="75px">
            Продлить аренду на
          </th>

          <th className="table-inst-th" width="75px">
            Сумма доплаты
          </th>
          <th className="table-inst-th" width="75px"></th>
        </tr>
      </thead>

      <tbody>
        {data &&
          data.map((inst, i) => {
            let icon = 'instrument';

            if (inst.is_priced_by_wear) {
              icon = 'wheel';
            } else if (inst.components && opened.includes(inst.id)) {
              icon = 'tableminus';
            } else if (inst.components && !opened.includes(inst.id)) {
              icon = 'tableplus';
            }

            return (
              <React.Fragment key={inst.id}>
                <tr className="table-inst-tr" onClick={() => handleOpen(inst)}>
                  <th className="table-inst-th text-light">{i + 1}</th>

                  <th className="table-inst-th text-light" style={{ borderRight: 'none', textAlign: 'left' }}>
                    <Icon name={icon} style={{ margin: 'auto' }} />
                  </th>

                  <th className="table-inst-th text-light" align="start">
                    {inst.title}
                  </th>
                  <th className="table-inst-th" width="50px">
                    {inst.rentTerm}
                  </th>

                  <th className="table-inst-th" width="100px">
                    <HiddenInput
                      canChange={canChange}
                      postfix=" сут."
                      value={inst.AdditionalRentTerm}
                      onChange={(value) => onAdditionalRentTermChange(value)}
                      min={1}
                      max={365}
                    />
                  </th>

                  <th className="table-inst-th" width="50px">
                    {inst.AdditionalRentTerm_amount * inst.quantity || 0} грн.
                  </th>

                  <th className="table-inst-th double-th">
                    <Icon name="calculator" onClick={() => handleCalculator(inst)} />
                    {calculator?.id === inst.id && (
                      <CalculatorModal
                        instrument={calculator || null}
                        onUpdate={handleChangeCalculator}
                        disabled={true}
                        onClose={() => handleCalculator(null)}
                        isFullPledge={isFullPledge}
                        setIsFullPledge={setIsFullPledge}
                      />
                    )}
                  </th>
                </tr>

                {opened.includes(inst.id) &&
                  inst.components &&
                  inst.components.map((comp) => (
                    <tr key={comp.id} className="table-inst-tr">
                      <th className="table-inst-th text-light"></th>

                      <th className="table-inst-th text-light" style={{ borderRight: 'none', textAlign: 'left' }}></th>

                      <th className="table-inst-th text-light" align="start">
                        {comp.title}
                      </th>

                      <th className="table-inst-th">
                        <HiddenInput
                          canChange={canChange}
                          value={comp.quantity || 0}
                          onChange={(value) => handleUpdateComponent(inst, comp.id, value)}
                        />
                      </th>

                      <th className="table-inst-th" width="75px"></th>
                      <th className="table-inst-th" width="50px"></th>

                      <th className="table-inst-th double-th">
                        {canChange && (
                          <Icon
                            name="trash"
                            onClick={(e) => handleRemoveComponent(inst, comp.id)}
                            style={{ margin: 'auto' }}
                          />
                        )}
                      </th>
                    </tr>
                  ))}
                {opened.includes(inst.id) && canChange && (
                  <tr className="table-inst-tr" style={{ padding: '8px' }}>
                    <th className="table-inst-th text-light"></th>
                    <th className="table-inst-th text-light" style={{ borderRight: 'none', textAlign: 'left' }}></th>
                    <th className="table-inst-th text-light" align="start">
                      <ButtonIcon
                        className="btn-add-component"
                        onClick={() => handleAddComponent(inst)}
                        icon="plus"
                        text="Добавить компонент"
                      />
                    </th>

                    <th className="table-inst-th" width="50px"></th>
                    <th className="table-inst-th" width="75px"></th>

                    <th className="table-inst-th" width="95px"></th>

                    <th className="table-inst-th"> </th>
                  </tr>
                )}
              </React.Fragment>
            );
          })}

        <tr className="table-inst-tr">
          <th className="table-inst-th text-light"></th>

          <th className="table-inst-th text-light" style={{ borderRight: 'none', textAlign: 'left' }}></th>

          <th className="table-inst-th text-light" align="start"></th>

          <th className="table-inst-th" width="50px"></th>

          <th className="table-inst-th" width="75px"></th>
          <th className="table-inst-th" width="95px">
            {rentSum.AdditionalRentTermAmount} грн.
          </th>

          <th className="table-inst-th"></th>
        </tr>
      </tbody>
    </table>
  );
};

TableContinueInstruments.propTypes = {
  data: PropTypes.array,
  opened: PropTypes.array,
  canChange: PropTypes.bool,
  rentSum: PropTypes.object,
  handleRemoveComponent: PropTypes.func,
  handleAddComponent: PropTypes.func,
  handleUpdateComponent: PropTypes.func,
  handleRemove: PropTypes.func,
  handleChangeCalculator: PropTypes.func,
  handleOpen: PropTypes.func,
  onUpdate: PropTypes.func,
  rateVAT: PropTypes.number,
  calculator: PropTypes.object,
  handleCalculator: PropTypes.func,
  isFullPledge: PropTypes.bool,
  setIsFullPledge: PropTypes.func,
};

TableContinueInstruments.defaultProps = {
  opened: [],
  canChange: true,
};

export { TableContinueInstruments };
